import { useEffect, useState } from "react";

import { apiClient } from "@/services/apiClient";

/**
 * Loads the signed-in user's profile picture via GET /auth/me/avatar-image (Bearer auth)
 * and returns a blob object URL for use in img (private Vercel Blob URLs are not usable as raw src).
 */
export function useMyProfileAvatarObjectUrl(
  storedProfileImageUrl: string | null | undefined
): string | null {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (storedProfileImageUrl == null || storedProfileImageUrl.trim() === "") {
      setSrc(null);
      return;
    }

    const controller = new AbortController();

    void (async () => {
      try {
        const res = await apiClient.get("/auth/me/avatar-image", {
          responseType: "blob",
          signal: controller.signal,
        });
        if (controller.signal.aborted) {
          return;
        }
        const objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      } catch {
        if (!controller.signal.aborted) {
          setSrc(null);
        }
      }
    })();

    return () => {
      controller.abort();
      setSrc((prev) => {
        if (prev != null) {
          URL.revokeObjectURL(prev);
        }
        return null;
      });
    };
  }, [storedProfileImageUrl]);

  return src;
}
